// JsFromRoutes CacheKey 75e68037a8fb99e038b82b3bde48ac23
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/storage/disk/:encoded_key/*filename'),
}
